import { render, staticRenderFns } from "./folder_selector.vue?vue&type=template&id=39a673b4&scoped=true&"
import script from "./folder_selector.vue?vue&type=script&lang=js&"
export * from "./folder_selector.vue?vue&type=script&lang=js&"
import style0 from "./folder_selector.vue?vue&type=style&index=0&id=39a673b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a673b4",
  null
  
)

export default component.exports